module.exports = __webpack_public_path__ + "media/fyt_m24.4a221a0e.mp4";